import React from "react";

export const Card = ({ children, className = "", testId }) => (
  <div data-testid={testId} className={`rounded-2xl border border-slate-800 bg-[#0f141c] ${className}`}>{children}</div>
);

export const CardHead = ({ icon: Icon, title, right }) => (
  <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-slate-800">
    <div className="flex items-center gap-2.5 min-w-0">
      {Icon && <Icon className="w-4 h-4 text-blue-400 flex-shrink-0" />}
      <h3 className="text-white text-sm font-semibold truncate">{title}</h3>
    </div>
    {right}
  </div>
);

const STATUS = {
  Live: "bg-emerald-500/15 text-emerald-400",
  Paid: "bg-emerald-500/15 text-emerald-400",
  Approved: "bg-emerald-500/15 text-emerald-400",
  Signed: "bg-emerald-500/15 text-emerald-400",
  Resolved: "bg-emerald-500/15 text-emerald-400",
  Processing: "bg-blue-500/15 text-blue-400",
  Pending: "bg-amber-500/15 text-amber-400",
  Requested: "bg-amber-500/15 text-amber-400",
  Open: "bg-amber-500/15 text-amber-400",
  Paused: "bg-slate-500/20 text-slate-300",
  "Below Buffer": "bg-slate-500/20 text-slate-300",
};

export const Badge = ({ children }) => (
  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold whitespace-nowrap ${STATUS[children] || "bg-slate-700 text-slate-200"}`}>{children}</span>
);

export const PageTitle = ({ title, sub, right }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6">
    <div>
      <h1 className="font-['Poppins'] text-2xl sm:text-3xl font-bold text-white">{title}</h1>
      {sub && <p className="mt-1 text-sm text-slate-400">{sub}</p>}
    </div>
    {right}
  </div>
);

export const Btn = ({ children, variant = "primary", className = "", ...props }) => (
  <button
    {...props}
    className={`inline-flex items-center justify-center gap-2 text-sm font-semibold px-4 py-2.5 rounded-xl transition-colors disabled:opacity-60 ${
      variant === "primary"
        ? "bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white"
        : "border border-slate-700 text-slate-200 hover:border-blue-500 hover:text-white"
    } ${className}`}
  >
    {children}
  </button>
);

export const inputCls = "w-full bg-[#0b0f15] border border-slate-700 rounded-lg px-3.5 py-2.5 text-sm text-slate-100 placeholder-slate-500 focus:border-blue-500 outline-none transition-colors";
